import {
  getStoreWarningInfo,
  getEnterpriseWarningInfo
} from '@/api/warningInfo';

const warningInfo = {
  state: {},
  actions: {
    fetchStoreWarningInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        getStoreWarningInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchEnterpriseWarningInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        getEnterpriseWarningInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  mutations: {}
};

export default warningInfo;



// WEBPACK FOOTER //
// ./src/store/modules/warningInfo.js